import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      redirect: "/login"
    },
    {
      path: "/Home",
      name: "Home",
      component: resolve => require(["@/components/Home"], resolve), //懒加载
      meta: {
        title: "首页"
      },
      children: [
        {
          path: "/presentation",
          component: resolve => require(["@/navigation/presentation"], resolve),
          meta: {
            title: "首页"
          }
        },
        {
          path: "/bigDate",
          component: resolve => require(["@/navigation/bigDate.vue"], resolve),
          meta: {
            title: "大数据"
          }
        },
        {
          path: "/patientManage",
          component: resolve =>
            require(["@/navigation/patientManage.vue"], resolve),
          meta: {
            title: "患者管理"
          }
        },
        {
          path: "/bsDataManage",
          component: resolve =>
            require(["@/navigation/bsDataManage.vue"], resolve),
          meta: {
            title: "数据管理"
          }
        },
        {
          path: "/followUpManage",
          component: resolve =>
            require(["@/navigation/followUpManage.vue"], resolve),
          meta: {
            // title: "随访管理"
            title: "随访记录"
          }
        },
        {
          path: "/followUpFiles",
          component: resolve =>
            require(["@/navigation/followUpFiles/index.vue"], resolve),
          meta: {
            title: "随访档案"
          }
        },
        // {
        //   path: "/statistics",
        //   component: resolve =>
        //     require(["@/navigation/statistics.vue"], resolve),
        //   meta: {
        //     title: "血糖统计"
        //   }
        // },
        // {
        //   path: "/xyStatistics",
        //   component: resolve =>
        //     require(["@/navigation/xyStatistics.vue"], resolve),
        //   meta: {
        //     title: "血压统计"
        //   }
        // },
        {
          path: "/statistics",
          component: resolve =>
            require(["@/navigation/xsaStatistics/index.vue"], resolve),
          meta: {
            title: "血糖统计"
          }
        },
        {
          path: "/xyStatistics",
          component: resolve =>
            require(["@/navigation/xyStatistics/index.vue"], resolve),
          meta: {
            title: "血压统计"
          }
        },

        {
          path: "/xtStatistics",
          component: resolve =>
            require(["@/navigation/xtStatistics/index.vue"], resolve),
          meta: {
            title: "血酮统计"
          }
        },
        {
          path: "/xnsStatistics",
          component: resolve =>
            require(["@/navigation/xnsStatistics/index.vue"], resolve),
          meta: {
            title: "血尿酸统计"
          }
        },
        {
          path: "/testStripManage",
          component: resolve =>
            require(["@/navigation/testStripManage.vue"], resolve),
          meta: {
            title: "试条管理"
          }
        },
        {
          path: "/accuChekManage",
          component: resolve =>
            require(["@/navigation/accuChekManage.vue"], resolve),
          meta: {
            title: "仪器管理"
          }
        },
        {
          path: "/maintain",
          component: resolve => require(["@/navigation/maintain.vue"], resolve),
          meta: {
            title: "质控数据维护"
          }
        },
        {
          path: "/stripStatistics",
          component: resolve =>
            require(["@/navigation/stripStatistics.vue"], resolve),
          meta: {
            title: "试条用户量统计"
          }
        },
        {
          path: "/nurseStatistics",
          component: resolve =>
            require(["@/navigation/nurseStatistics.vue"], resolve),
          meta: {
            title: "护士工作统计"
          }
        },
        {
          path: "/infoSetting",
          component: resolve =>
            require(["@/navigation/infoSetting.vue"], resolve),
          meta: {
            title: "基本信息设置"
          }
        },
        {
          path: "/userManage",
          component: resolve =>
            require(["@/navigation/userManage.vue"], resolve),
          meta: {
            title: "医生管理"
          }
        },
        {
          path: "/nurseManage",
          component: resolve =>
            require(["@/navigation/nurseManage.vue"], resolve),
          meta: {
            title: "护士管理"
          }
        },
        {
          path: "/foodManage",
          component: resolve =>
            require(["@/navigation/foodManage.vue"], resolve),
          meta: {
            title: "食品库管理"
          }
        },
        {
          path: "/drugsManage",
          component: resolve =>
            require(["@/navigation/drugsManage.vue"], resolve),
          meta: {
            title: "药品库管理"
          }
        },
        {
          path: "/BannerManage",
          component: resolve =>
            require(["@/navigation/BannerManage.vue"], resolve),
          meta: {
            title: "banner管理"
          }
        },
        {
          path: "/realTimeInfoManage",
          component: resolve =>
            require(["@/navigation/realTimeInfoManage.vue"], resolve),
          meta: {
            title: "资讯管理"
          }
        },
        {
          path: "/systemNewsManage",
          component: resolve =>
            require(["@/navigation/systemNewsManage.vue"], resolve),
          meta: {
            title: "系统消息管理"
          }
        },
        {
          path: "/addDoc",
          component: resolve => require(["@/navigation/addDoc.vue"], resolve),
          meta: {
            title: "医生信息"
          }
        },
        {
          path: "/departmentOne",
          component: resolve =>
            require(["@/navigation/departmentOne.vue"], resolve),
          meta: {
            title: "患者管理(下级机构)"
          }
        },
        {
          path: "/patientDetails",
          component: resolve =>
            require(["@/navigation/patientDetails.vue"], resolve),
          meta: {
            title: "患者详情"
          }
        },
        {
          path: "/releasEannounceM",
          component: resolve =>
            require(["@/navigation/releasEannounceM.vue"], resolve),
          meta: {
            title: "发布系统消息"
          }
        },
        {
          path: "/addBanner",
          component: resolve =>
            require(["@/navigation/addBanner.vue"], resolve),
          meta: {
            title: "新增banner"
          }
        },
        {
          path: "/addInformation",
          component: resolve =>
            require(["@/navigation/addInformation.vue"], resolve),
          meta: {
            title: "新增资讯"
          }
        },
        {
          path: "/changeBanner",
          component: resolve =>
            require(["@/navigation/changeBanner.vue"], resolve),
          meta: {
            title: "修改banner"
          }
        },
        {
          path: "/changeReleasEannounce",
          component: resolve =>
            require(["@/navigation/changeReleasEannounce.vue"], resolve),
          meta: {
            title: "编辑公告"
          }
        },
        {
          path: "/changeInformation",
          component: resolve =>
            require(["@/navigation/changeInformation.vue"], resolve),
          meta: {
            title: "修改资讯"
          }
        },
        {
          path: "/addDrugsManage",
          component: resolve =>
            require(["@/navigation/addDrugsManage.vue"], resolve),
          meta: {
            title: "新增药品"
          }
        },
        {
          path: "/addPatient",
          component: resolve =>
            require(["@/navigation/addPatient.vue"], resolve),
          meta: {
            title: "新增患者"
          }
        },
        {
          path: "/changePatient",
          component: resolve =>
            require(["@/navigation/changePatient.vue"], resolve),
          meta: {
            title: "修改患者"
          }
        },
        {
          path: "/addYSmap",
          component: resolve => require(["@/navigation/addYSmap.vue"], resolve),
          meta: {
            title: "选择食谱"
          }
        },
        {
          path: "/addYDmap",
          component: resolve => require(["@/navigation/addYDmap.vue"], resolve),
          meta: {
            title: "选择运动"
          }
        },
        {
          path: "/addYYmap",
          component: resolve => require(["@/navigation/addYYmap.vue"], resolve),
          meta: {
            title: "选择用药"
          }
        },
        {
          path: "/addXYmap",
          component: resolve => require(["@/navigation/addXYmap.vue"], resolve),
          meta: {
            title: "选择吸烟"
          }
        },
        {
          path: "/404",
          component: resolve => require(["@/components/404.vue"], resolve),
          meta: {
            title: "404"
          }
        },
        {
          path: "/menu",
          component: resolve => require(["@/navigation/menu.vue"], resolve),
          meta: {
            title: "菜单权限"
          }
        },

        // 总后台
        {
          path: "/generaIndex",
          component: resolve =>
            require(["@/generalBackstage/generaIndex.vue"], resolve),
          meta: {
            title: "机构账号管理"
          }
        },
        {
          path: "/generaBigDateSet",
          component: resolve =>
            require(["@/generalBackstage/generaBigDateSet.vue"], resolve),
          meta: {
            title: "大数据地图区域设置"
          }
        },
        {
          path: "/equipmentManage",
          component: resolve =>
            require(["@/generalBackstage/equipmentManage.vue"], resolve),
          meta: {
            title: "设备管理"
          }
        },
        {
          path: "/addEquipment",
          component: resolve =>
            require(["@/generalBackstage/addEquipment.vue"], resolve),
          meta: {
            title: "新增设备"
          }
        },
        {
          path: "/userOrder",
          component: resolve =>
            require(["@/generalBackstage/orderManage/order/allOrder/index.vue"], resolve),
          meta: {
            title: "用户订单"
          }
        },
        {
          path: "/integralOrder",
          component: resolve =>
            require(["@/generalBackstage/orderManage/order/allOrder/indexJF.vue"], resolve),
          meta: {
            title: "积分订单"
          }
        },
        {
          path: "/userGoods",
          component: resolve =>
            require(["@/generalBackstage/orderManage/product/index.vue"], resolve),
          meta: {
            title: "用户商品"
          }
        },
        {
          path: "/integralGoods",
          component: resolve =>
            require(["@/generalBackstage/orderManage/product/indexJF.vue"], resolve),
          meta: {
            title: "积分商品"
          }
        },
        {
          path: "/accountChecking",
          component: resolve =>
            require(["@/generalBackstage/orderManage/saleManage/index.vue"], resolve),
          meta: {
            title: "兑账管理"
          }
        },
        {
          path: "/addAccount",
          component: resolve =>
            require(["@/generalBackstage/addAccount.vue"], resolve),
          meta: {
            title: "新增账号"
          }
        },
        {
          path: "/changeAccount",
          component: resolve =>
            require(["@/generalBackstage/changeAccount.vue"], resolve),
          meta: {
            title: "编辑账号"
          }
        },
        {
          path: "/changeBigDate",
          component: resolve =>
            require(["@/generalBackstage/changeBigDate.vue"], resolve),
          meta: {
            title: "编辑区域"
          }
        },

        // 下级机构
        {
          path: "/departIndex",
          component: resolve =>
            require(["@/departMent/departIndex.vue"], resolve),
          meta: {
            title: "二级机构首页"
          }
        },
        {
          path: "/dpFoodManage",
          component: resolve =>
            require(["@/departMent/dpFoodManage.vue"], resolve),
          meta: {
            title: "食品库管理"
          }
        },
        {
          path: "/dpDrugsManage",
          component: resolve =>
            require(["@/departMent/dpDrugsManage.vue"], resolve),
          meta: {
            title: "药品库管理"
          }
        },
        {
          path: "/dpuserManage",
          component: resolve =>
            require(["@/departMent/dpuserManage.vue"], resolve),
          meta: {
            title: "医生管理"
          }
        },
        {
          path: "/dpaddDoc",
          component: resolve => require(["@/departMent/dpaddDoc.vue"], resolve),
          meta: {
            title: "新增医生"
          }
        },
        {
          path: "/dpnurseManage",
          component: resolve =>
            require(["@/departMent/dpnurseManage.vue"], resolve),
          meta: {
            title: "护士管理"
          }
        },
        {
          path: "/dpstripStatistics",
          component: resolve =>
            require(["@/departMent/dpstripStatistics.vue"], resolve),
          meta: {
            title: "试条用户量统计"
          }
        },
        {
          path: "/dpnurseStatistics",
          component: resolve =>
            require(["@/departMent/dpnurseStatistics.vue"], resolve),
          meta: {
            title: "护士工作统计"
          }
        },
        {
          path: "/dptestStripManage",
          component: resolve =>
            require(["@/departMent/dptestStripManage.vue"], resolve),
          meta: {
            title: "试条管理"
          }
        },
        {
          path: "/dpaccuChekManage",
          component: resolve =>
            require(["@/departMent/dpaccuChekManage.vue"], resolve),
          meta: {
            title: "仪器管理"
          }
        },
        {
          path: "/dpmaintain",
          component: resolve =>
            require(["@/departMent/dpmaintain.vue"], resolve),
          meta: {
            title: "质控数据维护"
          }
        },
        {
          path: "/dpfollowUpManage",
          component: resolve =>
            require(["@/departMent/dpfollowUpManage.vue"], resolve),
          meta: {
            title: "随访管理"
          }
        },

        {
          path: "/dpbsDataManage",
          component: resolve =>
            require(["@/departMent/dpbsDataManage.vue"], resolve),
          meta: {
            title: "数据管理"
          }
        },
        {
          path: "/dppatientManage",
          component: resolve =>
            require(["@/departMent/dppatientManage.vue"], resolve),
          meta: {
            title: "患者管理"
          }
        },
        {
          path: "/dpPatientDetails",
          component: resolve =>
            require(["@/departMent/dpPatientDetails.vue"], resolve),
          meta: {
            title: "患者详情"
          }
        },
        {
          path: "/dpaddYSmap",
          component: resolve =>
            require(["@/departMent/dpaddYSmap.vue"], resolve),
          meta: {
            title: "选择食谱"
          }
        },
        {
          path: "/dpaddYDmap",
          component: resolve =>
            require(["@/departMent/dpaddYDmap.vue"], resolve),
          meta: {
            title: "选择运动"
          }
        },
        {
          path: "/dpaddYYmap",
          component: resolve =>
            require(["@/departMent/dpaddYYmap.vue"], resolve),
          meta: {
            title: "选择用药"
          }
        },
        {
          path: "/dpaddXYmap",
          component: resolve =>
            require(["@/departMent/dpaddXYmap.vue"], resolve),
          meta: {
            title: "选择吸烟"
          }
        },
        {
          path: "/dpaddPatient",
          component: resolve =>
            require(["@/departMent/dpaddPatient.vue"], resolve),
          meta: {
            title: "新增患者"
          }
        },
        {
          path: "/dpchangePatient",
          component: resolve =>
            require(["@/departMent/dpchangePatient.vue"], resolve),
          meta: {
            title: "修改患者"
          }
        },
        {
          path: "/ECG",
          component: resolve => require(["@/navigation/ECG/ECG.vue"], resolve),
          meta: {
            title: "心电图"
          }
        }
      ]
    },
    {
      path: "/login",
      component: resolve => require(["@/navigation/login.vue"], resolve),
      meta: {
        title: "登录"
      }
    },
    // 登录测试
    {
      path: "/login1",
      component: resolve =>
        require(["@/navigation/login1/login1.vue"], resolve),
      meta: {
        title: "登录"
      }
    },
    {
      path: "/agreement",
      component: resolve => require(["@/navigation/agreement.vue"], resolve),
      meta: {
        title: "协议"
      }
    },
    {
      path: "/Privacy",
      component: resolve => require(["@/navigation/Privacy.vue"], resolve),
      meta: {
        title: "隐私协议"
      }
    },
    {
      path: "/outdemo",
      component: resolve =>
        require(["@/navigation/outdemo/index.vue"], resolve),
      meta: {
        title: "外部使用"
      }
    },

    {
      path: "/placeorder",
      component: resolve => require(["@/payRelyOn/placeorder.vue"], resolve),
      meta: {
        title: "H5下单"
      }
    },
    // 微信小程序隐私协议
    {
      path: "/privacyAgreement",
      component: resolve =>
        require(["@/agreement_wx/privacyAgreement.vue"], resolve),
      meta: {
        title: "小程序隐私协议"
      }
    },
    // 微信小程序隐私协议
    {
      path: "/privacyAgreementYinChuan",
      component: resolve =>
        require(["@/agreement_wx/privacyAgreementYinChuan.vue"], resolve),
      meta: {
        title: "小程序隐私协议"
      }
    },
    {
      path: "*",
      redirect: "/404",
      meta: {
        title: "404"
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js